import { l } from '@manychat/manyui'

export const ERROR_NOTIFICATIONS = {
  CONNECTION_LIMIT_EXCEEDED: l.makeTranslate(
    'This channel was connected to Manychat multiple times. Please <a class="c-pointer" style="text-decoration: underline;" href="{href}" target="_blank" rel="noreferrer">contact support</a> to unblock the channel connection.',
    {
      href: 'https://help.manychat.com/hc/en-us/articles/14281086345244-How-to-get-support-from-Manychat',
    },
  ),
  CONNECTION_BLOCKED_ACTIVE_TRIAL: l.makeTranslate(
    `This channel can't be connected while your account has an active trial.`,
  ),
  CONNECTION_RESTRICTED_COMPLIANCE: l.makeTranslate(
    `The channel you're trying to connect is restricted on our platform. Please contact <a class="c-pointer" style="text-decoration: underline;" href="{href}">our compliance team</a> if you need further assistance.`,
    {
      href: 'mailto:sanctions@manychat.com',
    },
  ),
  CONNECTION_NOT_ONBOARDED_ON_CLOUD_API: l.makeTranslate(
    `We couldn't connect your phone number to Manychat. To continue, you'll need to move it to another WhatsApp Business Account first.`,
  ),
  CONNECTION_BUSINESS_ACCOUNT_LOCKED: l.makeTranslate(
    `You can't complete the setup process because your business doesn't meet WhatsApp's policy requirements. Reach out to Meta Business Suite support for help. <a href="https://www.facebook.com/business/help/692706745267064" target="blank_" class="text-primary c-pointer">Learn more</a> about the policy requirements`,
  ),
  CONNECTION_PHONE_NUMBERS_ALREADY_CONNECTED: l.makeTranslate(
    `This phone number is currently linked to an existing Manychat account. To use it with a different account, please first disconnect it from the current account`,
  ),
}
